<template>
  <PrimaryLayout>
    <Block>
      <BlockHeader>
        <Alert
          v-for="(alert, index) in alerts"
          :key="'alert-' + index"
          class="login-alert"
          type="error">
          {{ alert }}
        </Alert>

        <h1>{{ $t('header_sign_in') }}</h1>
        <p>{{ $t('sign_in_body_nonbranded') }}</p>
      </BlockHeader>

      <BlockForm>
        <TextInput
          :label="$t('welcome_body_email_placeholder')"
          type="email"
          :placeholder="$t('sign_in_email_prompt')"
          v-model="email"
        />

        <TextInput
          :label="$t('welcome_body_password_placeholder')"
          type="password"
          :placeholder="$t('sign_in_password_prompt')"
          v-model="password"
        />
      </BlockForm>

      <BlockActions>
        <Button
          @click="doLogin"
          :disabled="loggingIn"
          :loading="loggingIn"
          :keys="['enter']"
        >
          {{ $t('button_sign_in') }}
        </Button>
        <a :href="`${authUrl}reset-password`" target="_blank">
          {{ $t('button_forgot_password') }}
        </a>
      </BlockActions>
    </Block>
  </PrimaryLayout>
</template>

<script>
import {
  mapActions, mapState, mapGetters
} from 'vuex'
import {
  Alert,
  Block,
  BlockHeader,
  BlockActions,
  BlockForm,
  Button,
  TextInput
} from '@neurotrack/web-shared-components'
import { getAppUrl, APP_NAMES } from '@neurotrack/web-core/src/util/urls'
import PrimaryLayout from '@/components/PrimaryLayout'
import { Analytics } from '@/util/env'

export default {
  components: {
    Alert,
    Block,
    BlockHeader,
    BlockActions,
    BlockForm,
    PrimaryLayout,
    TextInput,
    Button
  },
  data() {
    return {
      email: '',
      password: ''
    }
  },
  props: {
    inactivityLogout: {
      type: Boolean
    }
  },
  mounted() {
    this.checkMediaRecorder()

    if (this.isLoggedIn) {
      this.handleRedirect()
    }
  },
  methods: {
    ...mapActions('user', ['login', 'logout']),
    ...mapActions('video', ['checkMediaRecorder']),
    handleRedirect() {
      if (!this.login_error) {
        Analytics.track('Login', { success: true })
        this.$router.push('/')
      } else {
        Analytics.track('Login', { error: this.login_error })
        console.warn('error logging in', this.login_error)
      }
    },
    async doLogin() {
      const { email, password } = this
      await this.login({ email, password })
      this.handleRedirect()
    }
  },
  computed: {
    ...mapState('video', ['accessToCamera', 'errNoRecorder']),
    ...mapState('user', ['logging_in', 'login_error']),
    ...mapGetters('user', ['isLoggedIn']),
    loggingIn() {
      return this.logging_in || this.isLoggedIn
    },
    authUrl() {
      return getAppUrl(APP_NAMES.auth)
    },
    alerts() {
      const alerts = []
      if (this.login_error) {
        alerts.push(this.$t('alert_invalid_login_body'))
      }
      if (this.errNoRecorder) {
        alerts.push(this.$t('alert_unsupported_media_recorder'))
      }
      if (this.inactivityLogout) {
        alerts.push(this.$t('alert_session_expired'))
      }
      return alerts
    }
  }
}
</script>

<style lang="scss" scoped>

.login-alert {
  width: 100%
}
</style>
